module.exports = __webpack_public_path__ + "img/PD1506439131767635968.92fa0d25.png";